import { addMethod, object } from 'yup';

addMethod(object, 'isEmptyObject', function (anyArgsYouNeed) {
  const { message } = anyArgsYouNeed;
  return this.test('is-empty-object', message, function (value = {}) {
    const { path, createError } = this;
    if (Object.keys(value).length > 0) {
      return true;
    }
    return createError({ path, message });
  });
});
